import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-startup.png'
import bg2 from '../../assets/images/bg/bg-lines-two.png'
import client1 from '../../assets/images/client/01.jpg'
import saas from '../../assets/images/saas/1.png'

import hero from '../../assets/images/startup-hero.png'
import Navbar from "../../components/navbar";
import CompanyLogo from "../../components/companyLogo";
import FooterLight from "../../components/footerLight";
import ScrollTop from "../../components/scrollTop";

import { aboutImage, principles, startUpCounter } from "../../data/data";

import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import CountUp from 'react-countup';

import { FiArrowRight, MdOutlineCheckCircle, TbMailStar } from '../../assets/icons/icons'

export default function IndexStartup(){
    return(
        <>
        <Navbar/>

        <section className="bg-half-130 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="container">
                <div className="row mt-5 align-items-center">
                    <div className="col-md-6">
                        <div className="heading-title">
                            <h4 className="display-4 fw-bold">Better management <br/> for better <span className="text-primary">Startup</span></h4>
                            <p className="para-desc text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="subcribe-form mt-4">
                                <form>
                                    <div className="mb-3">
                                        <input type="email" id="email" name="email" className="border bg-white rounded" required placeholder="Email Address"/>
                                        <button type="submit" className="btn btn-primary">Get Started</button>
                                    </div>
                                </form>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                <label className="form-check-label" htmlFor="flexCheckDefault">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-5 mt-sm-0 pt-2 pt-sm-0">
                        <div className="ms-md-4">
                            <img src={hero} className="img-fluid" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div className="container">
                <CompanyLogo/>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">What we do ?</h6>
                            <h4 className="title mb-4">Explore our awesome features</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="row">
                            {principles.map((item,index) =>{
                                let Icon = item.icon
                                return(
                                    <div className="col-md-6 mt-5 pt-2" key={index}>
                                        <div className="d-flex features feature-primary rounded">
                                            <div className="icon text-center rounded-circle me-lg-4 me-3 mt-2">
                                                <h3 className="mb-0"><Icon/></h3>
                                            </div>
                                            <div className="flex-1">
                                                <h5>{item.title}</h5>
                                                <p className="text-muted mb-0">{item.desc}</p>
                                                <div className="mt-2">
                                                    <Link to="#" className="link">Read More <FiArrowRight className="fea icon-sm"/></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    
                    <div className="col-12 mt-5 pt-2 text-center">
                        <Link to="#" className="text-primary h6 mb-0">Explore all features <FiArrowRight className="fea icon-sm"/></Link>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <ResponsiveMasonry
                    columnsCountBreakPoints={{350: 1, 750: 2, 900: 4}}
                >
                    <Masonry>
                        {aboutImage.map((item, index) =>{
                            return(
                                <div className=" spacing picture-item" key={index}>
                                    <div className="card border-0 position-relative d-block shadow overflow-hidden rounded">
                                        <div className="card-body p-0">
                                            <img src={item} className="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Masonry>
                </ResponsiveMasonry>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-lg-9">
                        <div className="row" id="counter">
                            {startUpCounter.map((item, index) =>{
                                return(
                                <div className="col-md-4 mt-4 pt-2" key={index}>
                                    <div className="counter-box text-center">
                                        <h1 className="mb-0"><CountUp className="counter-value" end={item.number} start={0} />%</h1>
                                        <h6 className="counter-head text-muted">{item.title}</h6>
                                    </div>
                                </div> 
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-md-7">
                        <div className="me-lg-5">
                            <div className="section-title">
                                <h6 className="text-primary">Collaborate</h6>
                                <h4 className="title mb-4">Collaborate with your <br/> team anytime, anywhere.</h4>
                                <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            </div>

                            <ul className="list-unstyled text-muted mb-0 mt-4">
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Organize your data</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Work with any team</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Business analytics</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0 ms-1"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Always in sync</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Embedded analytics</li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-md-5 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <img src={saas} className="img-fluid" alt=""/>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10">
                        <div className="text-center">
                            <h1 className="display-2"><i className="mdi mdi-format-quote-open text-primary"></i></h1>
                            <p className="text-muted h5 fst-italic">" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "</p>

                            <div className="mt-4">
                                <img src={client1} className="img-fluid avatar avatar-md-md rounded-circle shadow" alt=""/>
                                <h6 className="text-primary mt-3 mb-0">Thomas Israel</h6>
                                <small className="text-muted">C.E.O</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="px-4 py-5 bg-dark bg-white-dark rounded shadow" style={{backgroundImage:`url(${bg2})`}}>
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <div className="section-title">
                                <div className="d-flex">
                                    <TbMailStar className="display-4 text-white title-dark"/>
                                    <div className="flex-1 ms-md-4 ms-3">
                                        <h4 className="fw-bold text-light title-dark mb-1">Subscribe to our newsletters</h4>
                                        <p className="text-white-50 mb-0">Sign up and receive the latest tips via email.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-4 mt-sm-0">
                            <div className="text-md-end ms-5 ms-sm-0">
                                <Link to="#" className="btn btn-primary">Subscribe Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <FooterLight/>
        <ScrollTop/>
        </>
    )
}